<template>
    <b-modal
        id="evaluate-project-modal"
        ref="evaluate-project-modal"
        :title="$t('project.check_assignments')"
        :ok-disabled="disabled"
        :ok-title="$t('project.check')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="onOk()"
        @show="onShow()"
        modal-class="apprentice-default-modal">
        <div
            class="evaluate-project"
            v-if="assignments.length">
            <div class="evaluate-type">
                <b-form-group :label="$t('project.check_by_assignment_or_by_student')">
                    <b-form-radio
                        class="apprentice-radiobutton"
                        v-model="type"
                        v-if="users.length"
                        name="some-radios"
                        value="1"
                        >{{ $t('project.check_by_student') }}
                    </b-form-radio>
                    <b-form-radio
                        class="apprentice-radiobutton"
                        v-model="type"
                        v-if="assignments.length"
                        name="some-radios"
                        value="2"
                        >{{ $t('project.check_by_assignment') }}
                    </b-form-radio>
                </b-form-group>
            </div>

            <div
                class="evaluate-per-student"
                v-if="type === '1'">
                <div class="description">
                    {{
                        $t(
                            'project.choose_which_student_you_want_to_check_only_students_who_have_submitted_something_are_in_this_list',
                        )
                    }}
                </div>
                <b-form-group
                    :label="$t('project.choose_student')"
                    label-for="evaluate-per-student-select">
                    <b-form-select
                        class="apprentice-primary-select"
                        v-model="selected_user">
                        <option
                            v-for="user in users"
                            :selected="selected_user === user.user.id ? 'selected' : ''"
                            :key="user.user.id"
                            :value="user.user.id">
                            {{ user.user.full_name }}
                        </option>
                    </b-form-select>
                </b-form-group>
            </div>

            <div
                class="evaluate-per-assignment"
                v-if="type === '2'">
                <div class="description">
                    {{
                        $t(
                            'project.choose_which_assignment_you_want_to_check_only_assignments_which_students_have_submitted_are_in_this_list',
                        )
                    }}
                </div>

                <b-form-group
                    :label="$t('project.choose_an_assignment')"
                    label-for="evaluate-per-assignment-select">
                    <b-form-select
                        class="apprentice-primary-select"
                        v-model="selected_assignment"
                        :options="assignments"
                        value-field="id"
                        text-field="name">
                    </b-form-select>
                </b-form-group>
            </div>
        </div>

        <div
            class="loading"
            v-show="loading"
            v-else-if="loading">
            <i class="fas fa-spinner fa-spin"></i>
        </div>

        <div
            class="not-found with-header empty-evaluation-list"
            v-else>
            <div class="icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="alert-notice">
                {{ $t('project.there_are_no_assignments_that_need_to_be_checked_in_this_group') }}
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-project-index-evaluate-modal-component',
    props: ['group'],
    data() {
        return {
            assignments: [],
            users: [],
            selected_user: null,
            selected_assignment: null,
            loading: false,
            type: '1',
        };
    },
    methods: {
        onShow() {
            this.assignments = [];
            this.users = [];
            this.selected_user = null;
            this.selected_assignment = null;
            this.loading = true;

            this.axios.get(this.routes.assignmentListByGroup(this.group.id)).then(
                (response) => {
                    this.loading = false;
                    this.assignments = response.data.assignments ?? [];
                    this.users = response.data.users ?? [];
                    this.users.unshift({ user: { id: null, full_name: this.$t('project.choose_student') } });
                    this.assignments.unshift({ d: null, name: this.$t('project.choose_an_assignment') });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        onOk() {
            if (this.type === '1') {
                for (const user of this.users) {
                    if (user.user.id !== this.selected_user) {
                        continue;
                    }

                    const project_id = user.projects[0].id;
                    const assignment_id = user.projects[0]['assignments'][0];

                    window.location.href =
                        this.routes.assignmentShow(assignment_id, project_id) +
                        '?evaluate=1&evaluate_type=1&evaluate_user=' +
                        user.user.id;

                    break;
                }
            } else if (this.type === '2') {
                for (const assignment of this.assignments) {
                    if (assignment.id !== this.selected_assignment) {
                        continue;
                    }
                    window.location.href =
                        this.routes.assignmentShow(assignment.id, assignment.projects[0].id) +
                        '?evaluate=1&evaluate_type=2';
                    break;
                }
            }
        },
    },
    computed: {
        disabled() {
            if (this.type === '1') {
                return !this.selected_user;
            } else if (this.type === '2') {
                return !this.selected_assignment;
            }
            return true;
        },
    },
};
</script>

<style scoped lang="scss">
.loading {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2rem;
    color: $primary;
    padding-top: map-get($grid-gutter-spacing, 'twenty-one');
    padding-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}
</style>
